import React from 'react';
import FeedItemWrapper from '../FeedItemWrapper';
import UltraFeedThreadItem from '../UltraFeedThreadItem';
import UltraFeedPostItem from '../UltraFeedPostItem';
import UltraFeedSpotlightItem from '../UltraFeedSpotlightItem';
import SuggestedFeedSubscriptions from '../../subscriptions/SuggestedFeedSubscriptions';
import { FeedItemSourceType } from '../ultraFeedTypes';
import type { UltraFeedSettingsType } from '../ultraFeedSettingsTypes';
import FeedMarker from '../FeedMarker';
import { UltraFeedDebugPostItem, UltraFeedDebugSpotlightItem, UltraFeedDebugThreadItem } from '../UltraFeedDebugItem';

export function createUltraFeedRenderers({ settings, debugMode = false }: { settings: UltraFeedSettingsType; debugMode?: boolean }) {
  return {
    feedCommentThread: {
      render: (item: FeedCommentThreadFragment, index: number) => {
        if (!item) return null;
        if (debugMode) {
          return <UltraFeedDebugThreadItem item={item} />;
        }
        const thread = {
          ...item,
          postSources: item.postSources as FeedItemSourceType[] | null,
        };
        return (
          <FeedItemWrapper>
            <UltraFeedThreadItem
              thread={thread}
              settings={settings}
              index={index}
            />
          </FeedItemWrapper>
        );
      },
    },
    feedPost: {
      render: (item: FeedPostFragment, index: number) => {
        if (!item) return null;
        if (debugMode) {
          return <UltraFeedDebugPostItem item={item} />;
        }
        return (
          <FeedItemWrapper>
            <UltraFeedPostItem
              post={item.post}
              postMetaInfo={item.postMetaInfo}
              settings={settings}
              index={index}
            />
          </FeedItemWrapper>
        );
      },
    },
    feedSpotlight: {
      render: (item: FeedSpotlightFragment, index: number) => {
        if (!item || !item.spotlight) return null;
        if (debugMode) {
          return <UltraFeedDebugSpotlightItem item={item} />;
        }
        const metaInfo = item.spotlightMetaInfo ? {
          ...item.spotlightMetaInfo,
          sources: item.spotlightMetaInfo.sources as FeedItemSourceType[],
        } : undefined;
        return (
          <FeedItemWrapper>
            <UltraFeedSpotlightItem
              spotlight={item.spotlight}
              post={item.post ?? undefined}
              spotlightMetaInfo={metaInfo}
              showSubtitle={true}
              index={index}
            />
          </FeedItemWrapper>
        );
      },
    },
    feedSubscriptionSuggestions: {
      render: (item: FeedSubscriptionSuggestionsFragment, index: number) => {
        if (!item || !item.suggestedUsers) return null;
        return (
          <FeedItemWrapper>
            <SuggestedFeedSubscriptions
              suggestedUsers={item.suggestedUsers}
            />
          </FeedItemWrapper>
        );
      },
    },
    feedMarker: {
      render: (item: FeedMarkerFragment) => {
        if (!item) return null;
        return (
          <FeedMarker
            timestamp={item.timestamp}
            markerType={item.markerType}
          />
        );
      },
    },
  } as const;
}

